import axios from 'axios';
import { API_PATH } from '../../../constants';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import actions from './actions';

const options = {
  name: 'certifications',
  baseType: 'CERTIFICATIONS',
  apiEndpoint: 'certifications'
};

const defaultOperations = createMetadataAPIOperations(options);

// This is for making the API call to update the skills that a membership has
// when the skill checkbox is clicked
const assignSkill =
  ({ membershipId, skillId, possessed, time, comments }) =>
  dispatch => {
    const data = { possessed, skill_id: skillId, time, comments };

    return axios.post(`${API_PATH}/memberships/${membershipId}/certifications`, data).then(response => {
      if (response.data.length === 0) {
        // If the response is empty, it means that the certification was deleted
        dispatch(actions.clearCertifications(membershipId));
      } else {
        dispatch(actions.fetchSuccessful(response.data, { replace: true }));
      }
    });
  };

export default {
  ...defaultOperations,
  assignSkill
};
